import shared from './shared';
import login from './login';
import changePassword from './changePassword';
import forgetPassword from './forgetPassword';
import tempPassword from './tempPassword';
import admins from './admins';
import inputsValidations from './inputsValidations';
import serviceProviderCategories from './serviceProviderCategories';
import specialties from './specialties';
import pagesTitles from './pagesTitles';
import serviceProviders from './serviceProviders';
import services from './services';
import successMsgs from './successMsgs';
import branches from './branches';
import publishRequests from './publishRequests';
import bookings from "./bookings";
import settings from "./settings"
import employees from './employees';
import customers from './customers';
import notifications from "./notifications";
import paymentTransactions from './paymentTransactions';
import outStandingBalance from './outStandingBalance';
import lookupsRequests from './lookupsRequests';
import mimarProfit from './mimarProfit';

const en = {
  shared,
  login,
  changePassword,
  forgetPassword,
  tempPassword,
  admins,
  inputsValidations,
  serviceProviderCategories,
  specialties,
  pagesTitles,
  serviceProviders,
  services,
  successMsgs,
  branches,
  publishRequests,
  bookings,
  settings,
  employees,
  customers,
  notifications,
  paymentTransactions,
  outStandingBalance,
  lookupsRequests,
  mimarProfit
};

export default en;
